@if (data$ | async; as data) {
  @if (data.itemTitle) {
    <h2>{{ data.itemTitle }}</h2>
  }
  @if (data.description) {
    <div class="desc">{{ data.description }}</div>
  }
  <div class="banner {{ data.styleClasses }}">
    @if (data.image) {
      <app-gg-media-with-mobile-media
        [container]="data.image"
        [mobileContainer]="data.mobileImage"
      ></app-gg-media-with-mobile-media>
    }
  </div>
  <div class="item">
    @if (data.linkToItemId) {
      <a (click)="scrollTo(data.linkToItemId)" class="anchor">
        @if (data.linkToItemId) {
          <i class="icon" aria-hidden="true"></i>
        }
        @if (data.subtitle) {
          <p>{{ data.subtitle }}</p>
        }
      </a>
    }
    @if (!data.linkToItemId && data.subtitle) {
      <p>{{ data.subtitle }}</p>
    }
    @if (data.link) {
      <div class="btn-container">
        @if (data.link) {
          <cx-generic-link [class]="'btn-more'" [target]="getTarget(data.link.target)" [url]="data.link.locUrl || []">{{
            data.link.linkName
          }}</cx-generic-link>
        }
        @if (data.link2) {
          <cx-generic-link [target]="getTarget(data.link2.target)" [url]="data.link2.locUrl || []">{{
            data.link2.linkName
          }}</cx-generic-link>
        }
      </div>
    }
  </div>
}
